
import React from "react";
import { motion } from "framer-motion";

export const GodsWordSection = () => {
  return (
    <section className="py-16 md:py-24 bg-heaven-accent relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-[#1A1F2C] mb-6">
            God's Word. Our Code. Your Calling.
          </h2>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img 
              src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//about%203.png" 
              alt="God's Word Our Code" 
              className="rounded-xl shadow-lg w-full"
            />
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-lg text-gray-700">
              We get it. "AI" and "faith" don't usually show up in the same sentence. But let's be clear:
            </p>
            
            <p className="text-lg text-gray-700 font-medium">
              Selah isn't powered by AI. It's powered by the Word.
            </p>
            
            <p className="text-lg text-gray-700">
              Yes, we use AI. But not to manipulate truth—to magnify it. Every answer you get from Selah 
              is grounded in Scripture, filtered through faith, and aimed at eternal impact.
            </p>
            
            <p className="text-lg text-gray-700">
              AI can generate text.
            </p>
            
            <p className="text-lg text-gray-700">
              Only the Word transforms hearts.
            </p>
            
            <p className="text-lg text-gray-700">
              We've built guardrails, prayerfully trained the system, and refused to compromise. 
              This is AI at the feet of the King.
            </p>
            
            <p className="text-xl italic text-heaven-gold font-medium text-center my-8">
              "This is AI at the feet of the King"
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
